import { useI18n } from '@oneaudi/i18n-context';
import { Headline, Layout, Text, TextButton } from '@oneaudi/unified-web-components';
import React from 'react';
import styled from 'styled-components';
import { messages } from '../../i18n/messages';

interface DealerSearchIntroProps {
  handleSetShowDealerSearch: () => void;
}

const StyledLayout = styled(Layout)`
  width: auto;
`;

const DealerSearchIntro: React.FC<DealerSearchIntroProps> = ({ handleSetShowDealerSearch }) => {
  const heading = useI18n(messages.dealership_connect_heading);
  const body = useI18n(messages.dealership_connect_body);
  const buttonText = useI18n(messages.dealership_connect_button);

  return (
    <StyledLayout
      align="flex-start"
      columnGap="24px"
      direction="column"
      justify="flex-start"
      padding={['var(--spacing-relative-lg)']}
      rowGap="var(--spacing-relative-lg)"
    >
      <Headline
        variant={{
          order: '4',
          type: 'headline',
          weight: 'normal',
        }}
        tag="h2"
      >
        {heading}
      </Headline>
      <Text>
        <span
          dangerouslySetInnerHTML={{
            __html: body,
          }}
        />
      </Text>
      <TextButton
        aria-label={buttonText}
        iconPosition="leading"
        icon="poi"
        onClick={handleSetShowDealerSearch}
        size="md"
        title={buttonText}
        variant="secondary"
      >
        {buttonText}
      </TextButton>
    </StyledLayout>
  );
};

export default DealerSearchIntro;
